import { chatManagementRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";

const permission = "all";

const chatManagementRouteMetadata: IRouteMetadataObj<
  typeof chatManagementRoutesObj
> = {
  view: {
    title: "messages.view.title",
    description: "messages.view.description",
    lazy: () => import("@/pages/chat/page"),
    mode: "create",
    type: "inner",
    icon: "Message3Line",
    breadcrumbs: [],
    permission,
    isPageFullMode: true,
  },
};

export const chatManagementRoutes = createRoute<typeof chatManagementRoutesObj>(
  chatManagementRoutesObj,
  chatManagementRouteMetadata,
);
